import React from 'react';

import { getTransactionStatusLabel, getTransactionStatusUi } from '../../constants';
import { BaseStatusChip } from '.';
import { TransactionStatus } from '../../../../store/modules/orders/types';

interface Props {
  status: TransactionStatus;
  size?: 'small' | 'medium';
}

export const TransactionStatusChip = ({ status, size = 'small' }: Props): JSX.Element => (
  <BaseStatusChip
    color={getTransactionStatusUi(status).color}
    icon={getTransactionStatusUi(status).icon}
    label={getTransactionStatusLabel(status)}
    size={size}
    textOnly
  />
);
